import { render, staticRenderFns } from "./AccountSetupWidget.vue?vue&type=template&id=acbf6a30"
import script from "./AccountSetupWidget.vue?vue&type=script&lang=js"
export * from "./AccountSetupWidget.vue?vue&type=script&lang=js"
import style0 from "./AccountSetupWidget.vue?vue&type=style&index=0&id=acbf6a30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports